export default "__VITE_ASSET__DMlyOboa__"